import { PhoneCall, MessageSquare, StickyNote, Share2 } from "lucide-react";

export type GenieCapability = {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  ctaLabel: string;
  ctaAction: "open_demo" | "navigate" | "none";
  ctaTarget?: string;
};

export const genieCapabilities: GenieCapability[] = [
  {
    id: "instant-answers",
    title: "Answer customer questions instantly",
    description: "Genies respond 24/7 via web, voice, or chat — no wait time.",
    icon: MessageSquare,
    ctaLabel: "See example",
    ctaAction: "open_demo",
    ctaTarget: "support",
  },
  {
    id: "guided-voice",
    title: "Guide users step-by-step with voice",
    description: "Natural conversations that collect details and move users forward.",
    icon: PhoneCall,
    ctaLabel: "Try voice flow",
    ctaAction: "open_demo",
    ctaTarget: "sales",
  },
  {
    id: "structured-data",
    title: "Capture and report structured data",
    description: "Turn chats into leads, tickets, or bookings — clean and exportable.",
    icon: StickyNote,
    ctaLabel: "View sample",
    ctaAction: "open_demo",
    ctaTarget: "booking",
  },
  {
    id: "easy-sharing",
    title: "Share anywhere in seconds",
    description: "Phone number, QR code, link, or website embed — your choice.",
    icon: Share2,
    ctaLabel: "How sharing works",
    ctaAction: "navigate",
    ctaTarget: "/genie-hub/my-genies",
  },
];
